document.addEventListener('DOMContentLoaded', function() {
	const personItems = document.querySelectorAll('.person__item');
	personItems.forEach((item, index) => {
		setTimeout(() => {
			item.classList.remove('is-hidden');
		}, (index + 1) * 300);
	});

	// Pobierz wszystkie elementy .js-people-item
	const peopleItems = document.querySelectorAll('.js-people-item');

	// Dodaj nasłuchiwacz zdarzeń kliknięcia do każdego elementu
	peopleItems.forEach((item) => {
		item.addEventListener('click', function() {
			// Pobierz data-person-id z klikniętego elementu
			const personId = this.getAttribute('data-person-id');

			// Usuń klasę is-hidden z .js-people-open-modal
			const modal = document.querySelector('.js-people-open-modal');
			if (modal) {
				modal.classList.remove('is-hidden');
			}

			// Dodaj klasę is-mobile-open do body
			document.body.classList.add('is-mobile-open');

			// Przeszukaj wszystkie .js-people-item-modal
			const modalItems = document.querySelectorAll(
				'.js-people-item-modal'
			);
			modalItems.forEach((modalItem) => {
				// Sprawdź, czy data-person-id się zgadza
				if (modalItem.getAttribute('data-person-id') === personId) {
					// Usuń klasę is-hidden, jeśli id się zgadza
					modalItem.classList.remove('is-hidden');
				} else {
					// Dodaj klasę is-hidden, jeśli id się nie zgadza
					modalItem.classList.add('is-hidden');
				}
			});
		});
	});

	// Dodaj nasłuchiwacz zdarzeń kliknięcia do elementu zamykającego modal
	const closeModalButton = document.querySelector('.js-people-close-modal');
	if (closeModalButton) {
		closeModalButton.addEventListener('click', function() {
			// Dodaj klasę is-hidden do .js-people-open-modal
			const modal = document.querySelector('.js-people-open-modal');
			if (modal) {
				modal.classList.add('is-hidden');
			}

			// Dodaj klasę is-hidden do wszystkich .js-people-item-modal
			const modalItems = document.querySelectorAll(
				'.js-people-item-modal'
			);
			modalItems.forEach((modalItem) => {
				modalItem.classList.add('is-hidden');
			});

			// Usuń klasę is-mobile-open z body
			document.body.classList.remove('is-mobile-open');
		});
	}
});
